import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { heroImages } from '../../data/mock';

const Hero = () => {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-12 md:pb-20" style={{ background: '#FFFFFF' }}>
      <div className="container-x px-6">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-6">
          <span className="h-2 w-2 rounded-full" style={{ background: '#2EF5FF' }} />
          <span className="text-xs md:text-sm uppercase tracking-[0.2em] font-medium text-[#12367F]/70">
            Nasu Agency
          </span>
        </div>

        <h1
          className="font-display uppercase text-[#12367F] text-balance"
          style={{ fontSize: 'clamp(3rem, 9vw, 9.5rem)', lineHeight: 0.88 }}
        >
          The 360<sup className="text-[0.4em] align-super">°</sup> Social-First<br />
          <span className="inline-block px-3 md:px-5 py-1 md:py-2 rounded-2xl mt-2" style={{ background: '#2EF5FF' }}>
            Influencer Marketing
          </span>{' '}
          Agency
        </h1>

        <div className="mt-10 flex flex-wrap gap-3">
          <a href="/services" className="btn-base btn-primary">
            Explore our services <ArrowUpRight className="h-4 w-4" />
          </a>
          <a href="/contact" className="btn-base btn-outline-dark">
            Book a free strategy session <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>

      {/* Image strip */}
      <div className="mt-16 md:mt-24 overflow-hidden">
        <div className="flex gap-3 md:gap-4 px-6">
          {heroImages.concat(heroImages).map((src, i) => (
            <div
              key={i}
              className="relative shrink-0 rounded-2xl overflow-hidden"
              style={{
                width: 'clamp(160px, 18vw, 320px)',
                aspectRatio: '3 / 4'
              }}
            >
              <img
                src={src}
                alt=""
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
